// extracted by mini-css-extract-plugin
module.exports = {"jenga":"jenga_jenga__3ZnEe","item":"jenga_item__1VjnF","top-left":"jenga_top-left__1Y1kA","top-right":"jenga_top-right__1bzg-","bottom":"jenga_bottom__KKoU9"};